import { createUseStyles } from "react-jss";

export default createUseStyles ( theme => {
	return {
		root: {
			flexGrow: 1
		},
		menuButton: {
			marginRight: "35px"
		},
		headerStyles: {
			left            : "0",
			position        : "static",
			backgroundColor : theme.colors.body.primary,
			boxShadow       : "none"
		},
		title: {
			flex         : 3,
			display      : "flex",
			// justifyContent : "space-between",
			alignItems   : "center",
			borderRadius : "3px",
			margin       : "10px",
			background   : theme.colors.body.primary
			// position     : "absolute",
			// right        : "50%",
			// transform    : "translateX(50%)"
		},
		navDrawer: {
			display    : "flex",
			height     : "100vh",
			width      : "100%",
			maxWidth   : "600px",
			background : "rgba(0, 0, 0, 0.75)",
			position   : "fixed",
			top        : "0",
			left       : "0",
			zIndex     : "2000"
		},
		navContainer: {
			width      : "80%",
			maxWidth   : "600px",
			height     : "100vh",
			background : "white"
		},
		guestContainer: {
			height          : "80px",
			backgroundColor : "#1566c7",
			padding         : "20px 15px",
			display         : "flex",
			alignItems      : "center",
			color           : "white"
		},
		guestIcon: {
			width           : "40px",
			height          : "40px",
			backgroundColor : "rgba(0, 0, 0, 0.3)",
			borderRadius    : "50%",
			display         : "flex",
			alignItems      : "center",
			justifyContent  : "center"
		},
		tabsItem: {
			display        : "flex",
			alignItems     : "center",
			justifyContent : "center",
			width          : "30px"
		},
		tabsContainer: {
			display            : "flex",
			alignItems         : "center",
			backgroundPosition : "center",
			padding            : "10px 0",
			paddingLeft        : "15px",
			transition         : "background 0.8s",
			"&:focus"          : {
				background: "#1566c7 radial-gradient(circle, transparent 1%, #1566c7 1%) center/15000%"
			},
			"&:active": {
				backgroundColor : "#6eb9f7",
				backgroundSize  : "100%",
				transition      : "background 0s"
			}
		},
		appIconContainer: {
			display         : "flex",
			alignItems      : "center",
			margin          : "10px 0 50px",
			color           : "#343434",
			padding         : "10px 0",
			paddingLeft     : "15px",
			width           : "80%",
			position        : "absolute",
			bottom          : 0,
			backgroundColor : "#1566c7"
		},
		appIcon: {
			display        : "flex",
			alignItems     : "center",
			justifyContent : "center"
		},
		appInstall: {
			margin     : "0",
			marginLeft : "10px",
			fontSize   : "16px"
		},
		downloadText: {
			[theme.breakpoints.down ( "340" )]: {
				fontSize: "12px"
			},
			fontSize: "15px"
		},
		svgIconDark: {
			filter: theme.darkMode ? "none" : "invert(1)"
		},
		profileAvatar: {
			height : "2rem",
			width  : "2rem",
			filter : theme.darkMode ? "none" : "invert(1)"

		},
		svgIconLogo: {
			filter    : theme.darkMode ? "invert(1)" : "none",
			transform : "scale(1.2)"
		},
		toolbar: {
		},
		userAvatar: {
			height       : "2rem",
			width        : "2rem",
			borderRadius : "100%"
		}
	};
} );
